import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import cn from 'classnames';
import MenuStore from '../../stores/MenuStore';
import Button from '../Button';
import Dropdown from '../Dropdown';
import FuseButton from '../FuseControls/FuseButton';
import './MoreMenu.css';

const block = b.lock('MoreMenu');

class MoreMenu extends Component {
    static propTypes = {
        className: PropTypes.string,
        containerClassName: PropTypes.string,
        iconClassName: PropTypes.string,
        menuStore: MenuStore.PropType.isRequired,
        menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };

    static Item = ({ className, iconClassName, ...props }) => <Button
        className={cn(block('MenuItem'), className)}
        iconClassName={iconClassName}
        fullWidth
        noCenter
        {...props}
    />;

    state = {
        position: 'bottom',
    };

    getScrollableParent = (node) => {
        if (node == null) {
            return null;
        }

        const computedStyle = window.getComputedStyle(node);
        if (computedStyle.overflowX === 'auto' || computedStyle.overflowX === 'scroll' ||
            computedStyle.overflowY === 'auto' || computedStyle.overflowY === 'scroll') {
            return node;
        }

        return this.getScrollableParent(node.parentElement);
    };

    onToggle = () => {
        const { menuStore, menuId } = this.props;

        menuStore.toggle(menuId);

        if (menuStore.id == null) {
            return;
        }

        let menuPosition = 'bottom';
        const scrollableParent = this.getScrollableParent(this.container);
        if (scrollableParent) {
            const offsetTop = this.container.offsetTop - scrollableParent.offsetTop - scrollableParent.scrollTop;
            const scrollableParentCenter = scrollableParent.clientHeight / 2;
            if (offsetTop > scrollableParentCenter) {
                menuPosition = 'top';
            }
        }
        this.setState({ position: menuPosition });
    };

    render() {
        const { className, menuStore, menuId, children, containerClassName } = this.props;
        return <div
            className={cn(block(), containerClassName || '')}
            ref={(ref) => {
                this.container = ref;
            }}
        >
            <FuseButton
                active={menuStore.id === menuId}
                className={className}
                icon="more_vert"
                onClick={this.onToggle}
            />
            {menuStore.id === menuId ? <Dropdown
                className={block('Menu', { position: this.state.position })}
                onClose={menuStore.close}
            >{children}</Dropdown> : null}
        </div>;
    }
}

export default observer(MoreMenu);
